<template>
  <div>
    <Modal
      v-model="modal"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="140" label-colon>
          <FormItem prop="en" :label="$t('content') + '(en)'">
            <Input
              v-model="form.en"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="Please enter the treaty content"
            />
          </FormItem>
          <FormItem prop="tw" :label="$t('content') + '(繁体)'">
            <Input
              v-model="form.tw"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="請輸入條約內容"
            />
          </FormItem>
          <FormItem prop="zn" :label="$t('content') + '(简体)'">
            <Input
              v-model="form.zn"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="请输入条约内容"
            />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    return {
      form: {
        en: "",
        tw: "",
        zn: ""
      },
      ruleInline: {
        en: [
          {
            required: true,
            message: this.$t('Info.contentInput') + "(en)",
            trigger: "blur"
          }
        ],
        tw: [
          {
            required: true,
            message: this.$t('Info.contentInput') + "(繁体)",
            trigger: "blur"
          }
        ],
        zn: [
          {
            required: true,
            message: this.$t('Info.contentInput') + "(简体)",
            trigger: "blur"
          }
        ]
      },
    }

  },
  mounted () {

  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //   this.$base.showLoading();
          //   this.$request.sendPost(
          //     'mailinfo/upd',
          //     this.form,
          //     (success, data, error) => {
          //       this.$base.hideLoading();
          //       if (!success) return this.$base.alertErr(error.errmsg);
          //       this.cancel()
          //       this.$base.msgSuccess(this.$t("op_ok"));
          //       this.$refs.table.getLoad();
          //     }
          //   );
        } else {
          this.error()
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  margin: 20px 0 20px 10%;

  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/infoItem/module/infoItem_edit.vue